import React from 'react'
import { createPortal } from 'react-dom'
import * as CountyStyles from './CountySelector.module.scss'
import { COUNTIES } from '../../../lib/data/Sites'
import { fixAmpersands } from '../../../lib/utils'

interface CountySelectorProps {
  isOpen: boolean
  onClose: () => void
}

const CountySelector = ({ isOpen, onClose }: CountySelectorProps) => {
  const isBrowser = typeof window !== 'undefined'

  if (!isOpen) {
    return null
  }

  const overlay = (
    <div className={`${CountyStyles.Overlay}`}>
      <span>
        <ul>
          <li className={CountyStyles.NationalSelector}>
            <a href="https://muddystilettos.co.uk">
              <span>Select our:</span>National Site
            </a>
          </li>
          <li className={CountyStyles.LondonSelector}>
            <a href="https://london.muddystilettos.co.uk">London Site</a>
          </li>
          {COUNTIES.map(({ siteId, name: countyName, url }) => (
            <>
              {countyName !== 'London' && (
                <li key={siteId}>
                  <a href={url}>{fixAmpersands(countyName)}</a>
                </li>
              )}
            </>
          ))}
        </ul>
        <span className={CountyStyles.Close} onClick={() => onClose()}>
          Close
        </span>
      </span>
    </div>
  )

  return isBrowser ? createPortal(overlay, document.body) : null
}

export default CountySelector
